import { useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';
// AR Vision Demo — serve fixtures in demo mode (no-op in production).
import { arDemoActive, useArDemoFixture } from '@/demo/ar/hook-shim';

export function useArCustomerContacts(customerId: string) {
  const queryOptions =
    orpc.accountsReceivable.arCustomerContacts.list.queryOptions({
      input: { customerId },
      enabled: !!customerId && !arDemoActive(),
    });

  const query = useQuery(queryOptions);

  const demoContacts = useArDemoFixture((s) =>
    customerId ? s.bulkStatement.contactsByCustomer[customerId] : undefined,
  );

  if (arDemoActive()) {
    return {
      ...query,
      contacts: demoContacts ?? [],
    };
  }

  return {
    ...query,
    contacts: query.data?.contacts ?? [],
  };
}
